/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_1_PInputs */

const en_privacy_1_p = /** @type {(inputs: Privacy_1_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Account data: your name, email address and profile picture from Google Sign-In. Product data: the ideas, answers, PRDs, features, tasks, chat messages and attachments you create in Bystep. Codebase data: when you run \`bystep sync\`, the CLI uploads file paths, sizes and short summaries of your repository — never your source code or \`.env\` files. Technical data: IP address, browser type, pages visited and first-touch attribution (UTM parameters, referrer).`)
};

const id_privacy_1_p = /** @type {(inputs: Privacy_1_PInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data akun: nama, alamat email, dan foto profil dari Google Sign-In. Data produk: ide, jawaban, PRD, fitur, task, pesan chat, dan lampiran yang kamu buat di Bystep. Data codebase: saat kamu menjalankan \`bystep sync\`, CLI mengunggah path file, ukuran, dan ringkasan singkat repositori — tidak pernah kode sumber atau file \`.env\`. Data teknis: alamat IP, jenis browser, halaman yang dikunjungi, dan atribusi kunjungan pertama (parameter UTM, referrer).`)
};

/**
* | output |
* | --- |
* | "Account data: your name, email address and profile picture from Google Sign-In. Product data: the ideas, answers, PRDs, features, tasks, chat messages and at..." |
*
* @param {Privacy_1_PInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const privacy_1_p = /** @type {((inputs?: Privacy_1_PInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_1_PInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_1_p(inputs)
	return en_privacy_1_p(inputs)
});